import { getLocale } from '../lib/locale';

export const dateIsValid = (dateString: string) => {
	const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

	if (!regex.test(dateString)) return false;

	const [day, month, year] = dateString.split('/').map(Number);

	const date = new Date(year, month - 1, day);

	return (
		date.getDate() === day &&
		date.getMonth() === month - 1 &&
		date.getFullYear() === year
	);
};

export const dateStrToObj = (dateString: string, locale?: string) => {
	let day, month, year;
	if (locale === 'en-US')
		[month, day, year] = dateString.split('/').map(Number);
	else [day, month, year] = dateString.split('/').map(Number);

	return new Date(year, month - 1, day);
};

export const dateObjToStr = (date?: Date | string, hour: boolean = false) => {
	if (!date) return;
	if (typeof date === 'string') date = new Date(date);

	const options: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	};

	if (hour) {
		options['hour'] = '2-digit';
		options['minute'] = '2-digit';
		options['second'] = '2-digit';
		options['timeZone'] = 'America/Manaus';
		options['timeZoneName'] = 'short';
	}

	const locale = getLocale();

	const formatter = new Intl.DateTimeFormat(locale, options);
	return formatter.format(date);
};
